import React, { useState, useCallback, useEffect, useContext } from 'react';
import { Button, Modal, Stack } from 'react-bootstrap';
import { Table } from '@ai4/records-management';
import { textFilter } from '@ai4/react-bootstrap-table2-filter';
import { useDataRequest } from '@ai4/data-request';
import { FormViewer } from '@ai4/form-viewer';
import { Role } from '../types';
import RolesDetail from './Detail';
import { PermissionsContext } from 'src/context';
import $schema from './create.role.schema.json';
import Schema from '@ai4/form-viewer/dist/types/schema';

const COLUMNS = [
	{
		dataField: 'id',
		text: 'ID',
		hidden: true,
	},
	{
		dataField: 'name',
		text: 'Nome',
		sort: true,
		filter: textFilter(),
		formatter: (cell: string, row: any, rowIndex: number, formatExtraData: any) => {
			return (
				<div>
					<span>{row.name}</span>
					<br />
					<span className='row-subtitle'>{row.description}</span>
				</div>
			);
		},
	},
];

function RolesList() {
	const { canRoles } = useContext(PermissionsContext);
	const [create, setCreate] = useState<boolean>();
	const [selected, setSelected] = useState<Role>();
	const [rows, setRows] = useState<Role[]>([]);
	const { useRestRequest } = useDataRequest();
	const [req] = useRestRequest({
		path: 'api/{ver}/roles',
		method: 'GET',
		jwt: true,
	});
	const [reqSave] = useRestRequest({
		path: `api/{ver}/roles`,
		method: 'POST',
		jwt: true,
	});
	const [reqDelete] = useRestRequest({
		path: 'api/{ver}/roles/{id}',
		method: 'DELETE',
		jwt: true,
	});

	const load = async () => {
		const rows = await req();
		setRows(rows as Role[]);
	};

	const createItem = useCallback(async ({ values }) => {
		try {
			await reqSave({
				data: {
					...values,
				},
			});
			alert('Ruolo creato correttamente');
		} catch (e) {
			alert('Errore nel salvataggio');
		}
		await load();
		handleClose();
	}, []);

	const deleteItem = useCallback(async (row: any) => {
		await reqDelete({
			path: `api/{ver}/roles/${row.id}`,
		});
		await load();
	}, []);

	const handleClose = useCallback(() => {
		setCreate(false);
	}, []);

	useEffect(() => {
		load();
	}, []);

	if (selected) {
		return <RolesDetail id={selected.id} onBack={() => setSelected(undefined)} />;
	}

	return (
		<div>
			<Stack direction='horizontal' gap={3}>
				<div>
					<h1>Ruoli</h1>
				</div>
				<div>
					{canRoles && canRoles.create && (
						<div>
							<Button onClick={() => setCreate(true)}>Aggiungi nuovo</Button>
						</div>
					)}
				</div>
			</Stack>
			{create && (
				<Modal show onHide={handleClose}>
					<Modal.Header closeButton>
						<Modal.Title>Crea nuovo ruolo</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<FormViewer initialValues={{}} schema={$schema as Schema} onSubmit={createItem} />
					</Modal.Body>
				</Modal>
			)}
			<Table
				columns={COLUMNS}
				rows={rows}
				hideToggle
				hidePagination
				onSelectedRow={(row) => {
					setSelected(row);
				}}
				onDeleteRow={(row) => {
					deleteItem(row);
				}}
				checkFeature={(feature, row) => {
					if (feature === 'delete' && (!canRoles || !canRoles.delete)) {
						return false;
					}
					return true;
				}}
				/*
                hideEditColumns={true}
                onDelete={async (row) => {
                    await reqDelete({
                        path: `api/{ver}/roles/${row.id}`
                    });
                }}
                */
			/>
		</div>
	);
}

export default RolesList;
